// ------------------
// Handlers storage
// ------------------

const store = new Map();



// ------------------
// Click
// ------------------

const click = (el, cb) => function (event) {
    let node = event.target;
    while (node) {
        if (node === el) return;
        node = node.parentNode;
    }
    cb();
};



// ------------------
// Exports
// ------------------

export default {

    bind (el, binding) {
        store.set(el, click(el, binding.value));
        document.addEventListener('click', store.get(el));
    },

    unbind (el) {
        document.removeEventListener('click', store.get(el));
        store.delete(el);
    }

}

export function triggerClickAway () {
    store.forEach(handler => handler({target: null}));
}